"use strict";

export default class AnchorNavEvents {
  constructor() {
    const $anchorNav = $(".anchor-nav");
    const $desktopLinks = $(".desktop-only li", $anchorNav);
    const $mobileLinks = $(".no-desktop li", $anchorNav);
    let anchorNavHeight = $anchorNav.outerHeight();

    let isDesktop = $(window).width() >= 1024;
    let stickyAndVisible = false;
    let eventSectionPos = [];
    let eventBannerPos = $(".event-details-banner").length ? $(".event-details-banner").offset().top + $(".event-details-banner").outerHeight() : 0;
    let anchorStickPoint = eventBannerPos + anchorNavHeight + 30 - $(".site-header").outerHeight();

    if (isDesktop) {
      $anchorNav.addClass("on-desktop");
    } else {
      $anchorNav.removeClass("on-desktop");
    }

    const calcEventSectionPos = () => {
      return $(".event-details-section").map((i, ele) => {
        let $this = $(ele);
        
        return Math.floor($this.offset().top);
      });
    }

    eventSectionPos = calcEventSectionPos();
    
    window.emitter.on('bannerloaded', () => {
      eventSectionPos = calcEventSectionPos();
    });

    window.emitter.on('accordionOpened', () => {
      eventSectionPos = calcEventSectionPos();
    });

    let resizeTimer;
    $(window).on("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        eventSectionPos = $(".event-details-section").map((i, ele) => {
        let $this = $(ele);
        
        return Math.floor($this.offset().top);
      });
      }, 300);
    });

    $desktopLinks.map((i, ele) => {
      const $this = $(ele);
      const $link = $this.find("a");
      const target = $link.attr("href");

      $link.on("click", (e) => {
        e.preventDefault();

        $this.siblings(".active").removeClass("active");
        $this.addClass("active");

        if ($(target).length) {
          $("html, body").animate({
            scrollTop: $(target).offset().top - anchorNavHeight - $(".site-header").outerHeight() - 30,
          });
        }
      });

      if (i === 0) {
        $this.addClass("active");
      }
    });

    $mobileLinks.map((i, ele) => {
      const $link = $(ele).find("a");
      const target = $link.attr("href");

      $link.on("click", (e) => {
        e.preventDefault();

        const targetId = $link.attr("href");
        if(!$(targetId).hasClass('active')) {
          $("header", $(targetId)).trigger("click");
        }

        $(ele).siblings(".active").removeClass("active");
        $(ele).addClass("active");
        $(".label--current", $anchorNav).text($link.text());

        if ($anchorNav.hasClass("expanded")) {
          $anchorNav.removeClass("expanded");
        }

        if ($(target).length) {
          const anchorNavoffset = isDesktop ? $anchorNav.outerHeight() : 46; // 46px is height in mobile
          $("html, body").animate({
            scrollTop: $(target).offset().top - anchorNavoffset - $(".site-header").outerHeight(),
          });
        }
      });

      if (i === 0) {
        $(ele).addClass("active");
        $(".label--current", $anchorNav).text($link.text());
      }
    });

    const hash = window.location.hash;
    if ($(hash).length) {
      $("html, body").animate({
        scrollTop: $(hash).offset().top - anchorNavHeight - $(".site-header").outerHeight() - 30,
      });
    }

    let resizeTimeout;
    $(window).on("resize", (e) => {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        isDesktop = $(window).width() >= 1024;

        if (isDesktop) {
          $anchorNav.addClass("on-desktop");
        }
        else {
          $anchorNav.removeClass("on-desktop");
        }

        eventBannerPos = $(".event-details-banner").length ? $(".event-details-banner").offset().top + $(".event-details-banner").outerHeight() : 0;

        if (isDesktop) {
          anchorNavHeight = $anchorNav.outerHeight();
          $anchorNav.removeClass("expanded");
        } else {
          if ($anchorNav.hasClass("is-sticky")) {
            $anchorNav.addClass("invisible").removeClass("is-sticky");
            anchorNavHeight = $anchorNav.outerHeight();
            $anchorNav.addClass("is-sticky").removeClass("invisible");
          } else {
            anchorNavHeight = $anchorNav.outerHeight();
          }
        }

        anchorStickPoint = eventBannerPos + anchorNavHeight + 30 - $(".site-header").outerHeight();

        eventSectionPos = $(".event-details-section").map((i, ele) => {
          let $this = $(ele);
          return Math.floor($this.offset().top);
        });
      }, 200);
    });

    $("header button", $anchorNav).on("click", (e) => {
      e.preventDefault();

      if (!$anchorNav.hasClass("expanded")) {
        $anchorNav.addClass("expanded");
      } else {
        $anchorNav.removeClass("expanded");
      }
    });

    $(window).on("load.anchor", (e) => {
      let scrollTimeout;

      $(window).on("scroll.anchorNav", (e) => {
        // set anchor nav to be sticky
        if (isDesktop) {
          if ($(window).scrollTop() >= $(".event-details-banner").offset().top + $(".event-details-banner").outerHeight() - $(".site-header").outerHeight()) {
            $anchorNav.addClass("is-sticky");
          } else {
            $anchorNav.removeClass("is-sticky");
          }
        } else {
          if ($(window).scrollTop() >= 0) {
            // 30 from margin top of mobile anchors
            $anchorNav.addClass("is-sticky");

            if ($(window).scrollTop() >= 50) {
              $anchorNav.addClass("slide-down");
              stickyAndVisible = true;
            } else {
              if (stickyAndVisible) {
                $anchorNav.addClass("slide-up");
                $anchorNav.removeClass("slide-down");

                setTimeout(() => {
                  $anchorNav.removeClass("slide-up");
                  stickyAndVisible = false;
                }, 250);
              }
            }
          } else {
            $anchorNav.removeClass("is-sticky");
          }
        }

        anchorNavHeight = $anchorNav.outerHeight();

        // check scroll position against section position
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (isDesktop) {
            let activeSet = false;
            eventSectionPos.map((i, position) => {
              // add 1px here to remove uncertainty
              if ($(window).scrollTop() + 1 >= position - anchorNavHeight - $(".site-header").outerHeight() - 30) {
                $("li.active", $anchorNav).removeClass("active");
                $desktopLinks.eq(i).addClass("active");
                activeSet = true;

                clearTimeout(scrollTimeout);
              } else {
                // check if scroll to top and highlight back the first item
                if (i == 0) {
                  $("li.active", $anchorNav).removeClass("active");
                  $desktopLinks.eq(i).addClass("active");
                  activeSet = true;
                }
              }
            });
          } else {
            eventSectionPos.map((i, position) => {
              // add 1px here to remove uncertainty
              if ($(window).scrollTop() + 1 >= position - anchorNavHeight - $(".site-header").outerHeight() - 20) {
                $(".no-desktop li.active", $anchorNav).removeClass("active");
                $mobileLinks.eq(i).addClass("active");
                
                $(".label--current", $anchorNav).text(
                  $mobileLinks.eq(i).find("a").text()
                );

                clearTimeout(scrollTimeout);
              } else {
                // check if scroll to top and highlight back the first item
                if (i == 0) {
                  $(".no-desktop li.active", $anchorNav).removeClass("active");
                  $mobileLinks.eq(i).addClass("active");
                  $(".label--current", $anchorNav).text(
                    $mobileLinks.eq(i).find("a").text()
                  );
                }
              }
            });
          }
        }, 50);
      }).trigger("scroll.anchorNav");
    });
  }
}
